/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useContext, useState, useEffect, useRef} from "react";
import BlockContentHeaderComponent from "@Components/UI/Containers/Block/Header";
import BlockContentContainerComponent from "@Components/UI/Containers/Block";
import {Col, Row} from "react-bootstrap";
import {NavLink} from "react-router-dom";


type NotificationsListPageProps = {
    NOTIFICATIONS: any;
};


export const NotificationsListPageComponent: React.FC<NotificationsListPageProps> = ({
    NOTIFICATIONS = []
}): JSX.Element | null => {


    /** @const {React.Ref} My Favourite Terminals Page Container DOM Ref */
    const COMPONENT_REF: React.Ref<HTMLDivElement | null> = useRef(null);


    if (!NOTIFICATIONS) return null


    const NotificationsList = NOTIFICATIONS.map((NOTIFICATION: any, i: number) => {
        if (!NOTIFICATION.Caption && !NOTIFICATION.Text) return null;
        return (
            <Col key={i} xs={12} className={"notifications-list-notification"}>
                <Row as={NavLink} to={`/wiadomości/${NOTIFICATION.NotificationId}`} onClick={(e: any) => e.preventDefault()} className={"notifications-list-notification-content"}>
                    {!!NOTIFICATION.Caption &&
	                <Col xs={12} className={"notification-title"}>
		                <span>{NOTIFICATION.Caption}</span>
	                </Col>
                    }
                    {!!NOTIFICATION.Text &&
	                <Col xs={12} className={"notification-content"}>
		                <span>{NOTIFICATION.Text}</span>
	                </Col>
                    }
                </Row>
            </Col>
        );
    });


    return (
        <BlockContentContainerComponent forwardRef={COMPONENT_REF} cssClasses={"notifications-page-component page-container-component"}>

            <BlockContentHeaderComponent headerText={"Powiadomienia"} />

            {NOTIFICATIONS.length < 1 ?
            <Col xs={12} className={"no-list-elements-message default-system-message"}>
                <span>{`Brak powiadomień`}</span>
            </Col>
            :
            NotificationsList
            }

        </BlockContentContainerComponent>
    );

};


export default NotificationsListPageComponent;
